import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

import routesList from '../utils/requireRouter'
import { record } from '@/api'
Vue.use(VueRouter)

const routes = routesList

const router = new VueRouter({
    routes,
    // mode: 'history',
})

// 验签
function verificateIsCheck(to, next) {
    let is_bind = store.getters.userInfo.is_bind
    if (to.name == 'attestation') {
        next()
    } else if (to.name == 'errorPage') {
        next()
    }
    else {
        if (is_bind == 0) {
            next('/attestation')
        } else {
            next()
        }
    }

}

function verificateInfo(to, next) {
    if (store.getters.userInfo.avatar) {
        verificateIsCheck(to, next)
        // next()
    } else {
        store.dispatch('getUserInfo')
            .then(function () {
                verificateIsCheck(to, next)
                // next()
            })
    }
    // next()
}

function recordNum(tpe) {
    let params = {
        device: "WX",
        tpe: tpe
    }
    record(params).then(res => {
        // console.log(res)
    })
}
//路由守卫
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }

    if (!store.getters.token) {
        store.dispatch('getToken', {
            token: to.query.token
        })
            .then(function () {
                verificateInfo(to, next)
            })
    } else {
        verificateInfo(to, next)
    }
})

export default router
